import { getPermissions } from '@/store/authSlice'
import { useAppSelector } from '@/store/hooks'
import React, { useState, useEffect } from 'react'
import checkPermission from './checkPermission'
import {
  Debug,
  EntityOwnerId,
  Permissions,
  User,
  PermissionType,
} from './permission.types'

export type PermissionProps = {
  children: React.ReactElement
  noAccess?:
    | React.ReactElement
    | ((args: { user: User | null; hasAccess: boolean }) => React.ReactElement)
  permissions: Permissions
  type?: PermissionType
  entityOwnerId?: EntityOwnerId
  debug?: Debug
}
const Permission = (props: PermissionProps) => {
  const {
    children,
    noAccess,
    entityOwnerId,
    permissions = [],
    type = 'one-of',
    debug = false,
  } = props
  const currentUserPermissions: Permissions | undefined = useAppSelector(
    getPermissions
  )?.map?.((el) => el.name)
  const currentUser = useAppSelector((state) => state.auth)

  const [hasAccess, setHasAccess] = useState(
    currentUser
      ? checkPermission(
          {
            ...currentUser,
            permissions: currentUserPermissions || [],
          },
          permissions,
          {
            type,
            entityOwnerId,
            debug,
          }
        )
      : false
  )
  useEffect(() => {
    const user: User | null = {
      ...currentUser,
      permissions: currentUserPermissions || [],
    }
    if (!user?.access) {
      setHasAccess(false)
      return
    }
    const doesHaveAccess = checkPermission(user, permissions, {
      type,
      entityOwnerId,
      debug,
    })
    setHasAccess(!!doesHaveAccess)
  }, [
    entityOwnerId,
    permissions,
    type,
    currentUserPermissions,
    currentUser,
    debug,
  ])

  const renderNoAccess = () => {
    if (typeof noAccess === 'function') {
      return noAccess({
        user: {
          ...currentUser,
          permissions: currentUserPermissions || [],
        },
        hasAccess,
      })
    }
    return noAccess
  }
  return hasAccess ? children : renderNoAccess() || null
}

export default Permission
